<template>
  <b-modal
    ref="modal-delete"
    id="modal-delete"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="px-3 py-5 text-center">
      <img src="@/assets/icon-delete.png" alt="" width="120" height="120">
      <h4 class="text-bold mt-4">Delete {{ text }}</h4>
      <p class="text-muted mb-5">Are you sure want to delete this {{ text }} ?</p>
      <div class="d-flex justify-content-around align-items-center mt-5">
      <b-button class="btn-reset px-5" variant="outline-info" @click="remove">
        Yes
      </b-button>
      <b-button class="btn-custom px-5" variant="info" @click="$bvModal.hide('modal-delete')">
        No
      </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    text: {
      types: String,
      default: () => ''
    },
    form: {
      types: Object,
      default: () => ({})
    }
  },
  methods: {
    remove() {
      this.$bvModal.hide('modal-delete')
      this.$emit('click', this.form)
    }
  }
}
</script>
